import {
  productDetailsViewedEvent,
  productNoImagesEvent,
  productOutOfStockEvent,
  productUnavailableEvent,
} from 'common/models/TrackingEvents';
import { getProductTrackingData } from 'helpers/tracking/data/getProductTrackingData';
import { track } from 'helpers/tracking/tracking';
import { ProductDetailsPageProps } from 'store/appContext';

import { trackPdpBlocker } from './trackPdpBlocker';

export const trackPdpVisited = ({
  currencySymbol,
  department,
  isOutOfStock,
  productDetails: { product, userFacingDepartment },
}: {
  currencySymbol: string;
  department: string;
  isOutOfStock: boolean;
  productDetails: ProductDetailsPageProps;
}) => {
  const { images, isActive, isExcluded } = product;

  if (isExcluded || !isActive) {
    trackPdpBlocker({ department, eventName: productUnavailableEvent, product });
    return;
  }

  if (!images || images.length === 0) {
    trackPdpBlocker({ department, eventName: productNoImagesEvent, product });
    return;
  }
  track(productDetailsViewedEvent, getProductTrackingData(product, currencySymbol, { userFacingDepartment }));

  if (isOutOfStock) {
    trackPdpBlocker({ department, eventName: productOutOfStockEvent, product });
  }
};
